var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamificationFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.12 34.91C61.8 20.35 61.59 19.7 42.77 15.37C41.39 15.05 40.31 14.27 39.58 13.05C29.65 -3.51 28.97 -3.51 19.03 13.05C18.3 14.27 17.23 15.05 15.84 15.37C-2.97997 19.7 -3.18997 20.35 9.49003 34.91C10.42 35.98 10.83 37.24 10.71 38.66C9.01003 57.89 9.57003 58.29 27.33 50.74C28.64 50.18 29.96 50.18 31.27 50.74C49.04 58.3 49.59 57.9 47.89 38.66C47.76 37.25 48.18 35.98 49.11 34.91H49.12Z",
    fill: "url(#paint0_radial_63_28)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_63_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.12 34.91C61.8 20.35 61.59 19.7 42.77 15.37C41.39 15.05 40.31 14.27 39.58 13.05C29.65 -3.51 28.97 -3.51 19.03 13.05C18.3 14.27 17.23 15.05 15.84 15.37C-2.97997 19.7 -3.18997 20.35 9.49003 34.91C10.42 35.98 10.83 37.24 10.71 38.66C9.01003 57.89 9.57003 58.29 27.33 50.74C28.64 50.18 29.96 50.18 31.27 50.74C49.04 58.3 49.59 57.9 47.89 38.66C47.76 37.25 48.18 35.98 49.11 34.91H49.12Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_63_28)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.55
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1601 16.82C21.4801 17.26 21.2201 18.03 20.5401 18.5C19.8701 18.97 19.0401 18.96 18.7301 18.51C18.4101 18.06 18.7301 17.36 19.3901 16.89C20.0601 16.43 20.8401 16.38 21.1601 16.82Z",
    fill: "#699FCC"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2802 34.6C60.3802 20.7 60.1802 20.08 42.2202 15.95C40.9002 15.65 39.8702 14.9 39.1802 13.74C29.7002 -2.07 29.0502 -2.07 19.5702 13.74C18.8702 14.9 17.8502 15.65 16.5302 15.95C-1.42982 20.08 -1.63982 20.7 10.4702 34.6C11.3602 35.62 11.7502 36.83 11.6302 38.18C10.0102 56.54 10.5402 56.92 27.5002 49.71C28.7502 49.18 30.0202 49.18 31.2602 49.71C48.2202 56.93 48.7502 56.54 47.1302 38.18C47.0102 36.83 47.4002 35.62 48.2902 34.6H48.2802Z",
    fill: "url(#paint1_radial_63_28)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_63_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 55,
    height: 54
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2802 34.6C60.3802 20.7 60.1802 20.08 42.2202 15.95C40.9002 15.65 39.8702 14.9 39.1802 13.74C29.7002 -2.07 29.0502 -2.07 19.5702 13.74C18.8702 14.9 17.8502 15.65 16.5302 15.95C-1.42982 20.08 -1.63982 20.7 10.4702 34.6C11.3602 35.62 11.7502 36.83 11.6302 38.18C10.0102 56.54 10.5402 56.92 27.5002 49.71C28.7502 49.18 30.0202 49.18 31.2602 49.71C48.2202 56.93 48.7502 56.54 47.1302 38.18C47.0102 36.83 47.4002 35.62 48.2902 34.6H48.2802Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_63_28)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3302 21.67C24.5602 21.98 24.3702 22.53 23.8902 22.86C23.4102 23.19 22.8302 23.18 22.6102 22.86C22.3902 22.54 22.6102 22.04 23.0802 21.71C23.5502 21.38 24.1102 21.35 24.3302 21.66V21.67Z",
    fill: "#FFFBEB"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9799 6.24C27.8499 8.26 24.3799 14.37 21.8099 15.69C20.6499 16.38 20.0999 15.99 20.5899 14.45C21.1699 12.63 24.6599 6.98 26.3699 5.23C27.4299 4.14 28.0799 4.69 27.9799 6.25V6.24Z",
    fill: "url(#paint2_radial_63_28)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0701 38.31C45.1601 38.28 45.2101 38.59 45.2201 39.04C45.2201 39.5 45.1801 39.93 45.0901 39.97C45.0001 40.01 44.9001 39.64 44.8901 39.17C44.8901 38.7 44.9701 38.33 45.0601 38.3L45.0701 38.31Z",
    fill: "#FFB600"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6603 38.47C13.5703 38.44 13.5203 38.74 13.5103 39.18C13.5103 39.62 13.5503 40.04 13.6403 40.08C13.7303 40.12 13.8303 39.76 13.8403 39.31C13.8403 38.86 13.7603 38.5 13.6703 38.47H13.6603Z",
    fill: "#FF8500"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7798 17.86C41.7798 17.76 42.0798 17.81 42.5098 17.94C42.9298 18.07 43.3198 18.25 43.3298 18.35C43.3398 18.45 42.9698 18.43 42.5298 18.29C42.0998 18.15 41.7798 17.95 41.7798 17.85V17.86Z",
    fill: "#FFC715"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8498 5.2C27.7098 7.32 24.0798 13.72 21.3898 15.1C20.1798 15.82 19.5998 15.41 20.1198 13.8C20.7298 11.9 24.3798 5.98 26.1698 4.14C27.2798 2.99 27.9598 3.58 27.8598 5.21L27.8498 5.2Z",
    fill: "url(#paint3_radial_63_28)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7601 38.8C45.8501 38.77 45.9101 39.09 45.9201 39.57C45.9201 40.05 45.8801 40.5 45.7901 40.55C45.7001 40.59 45.5901 40.21 45.5801 39.72C45.5801 39.23 45.6701 38.84 45.7601 38.81V38.8Z",
    fill: "#61739E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8499 38.97C12.7599 38.94 12.6999 39.25 12.6899 39.71C12.6899 40.17 12.7299 40.61 12.8199 40.65C12.9099 40.69 13.0199 40.32 13.0299 39.85C13.0299 39.38 12.9399 39 12.8499 38.97Z",
    fill: "#61739E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3098 17.38C42.3098 17.28 42.6298 17.33 43.0698 17.47C43.5098 17.61 43.9198 17.8 43.9298 17.9C43.9398 18 43.5498 17.98 43.0898 17.84C42.6398 17.7 42.2998 17.48 42.2998 17.38H42.3098Z",
    fill: "#6E7FA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_63_28",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.48 13.88) scale(56.89 56.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#76AADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4570AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#335A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#365FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#416FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#548AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6EB1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3371B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_63_28",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0302 14.51) scale(47.66 47.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FECA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FCA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FA9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FA8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F38504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E06F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C75020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_63_28",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5299 23.98) scale(27.43 27.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#070705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1D1C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#413D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#726C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B2A982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2BB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_63_28",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9298 22.21) scale(24.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B1C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3C3E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6A6D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A4A8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DAE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamificationFilledStar);
export default __webpack_public_path__ + "static/media/gamification-filled-star.763d7fdaa7bbd974dc4a073ccb5f200f.svg";
export { ForwardRef as ReactComponent };